import api from '../lib/axios';
export const getPolls = () => api.get('/api/admin/polls').then((r) => r.data);
export const createPoll = (body) => api.post('/api/admin/polls', body).then((r) => r.data);
export const updatePoll = (id, body) => api.patch(`/api/admin/polls/${id}`, body);
export const deletePoll = (id) => api.delete(`/api/admin/polls/${id}`);
export const getPollResults = (id) => api.get(`/api/admin/polls/${id}/results`).then((r) => r.data);
